import React, {useContext} from "react";
import FormTranslationContext from "context/FormTranslationContext";
import Typography from "components/Typography";

function NoticeTypography
({
     children,
     formTrKey
 }) {
    const {formTr} = useContext(FormTranslationContext)

    return <Typography variant="h6">{formTrKey && formTr(formTrKey)}{children}</Typography>


}

export default NoticeTypography;